import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { CheckoutSection } from './components/CheckoutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { SocialProofPopup } from './components/SocialProofPopup';
import { initPixel, trackEvent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    // Set page title
    document.title = 'PSICOLOGÍA DEL APEGO MODERNO';
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Comprende tu estilo de apego y sana tus relaciones. Entendé por qué te enganchás de más, te cuesta soltar y repetís patrones.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Comprende tu estilo de apego y sana tus relaciones. Entendé por qué te enganchás de más, te cuesta soltar y repetís patrones.';
      document.head.appendChild(meta);
    }
    // Set Open Graph meta tags for social sharing
    const ogTags = [{
      property: 'og:title',
      content: 'PSICOLOGÍA DEL APEGO MODERNO'
    }, {
      property: 'og:description',
      content: 'Comprende tu estilo de apego y sana tus relaciones. Entendé por qué te enganchás de más, te cuesta soltar y repetís patrones.'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/1sUAJC4SxGmBDYRPVxvw9N/ChatGPT_Image_4_feb_2026,_14_36_30.png'
    }, {
      property: 'og:type',
      content: 'website'
    }];
    ogTags.forEach(({
      property,
      content
    }) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    });
    // Initialize Meta Pixel (PageView is tracked inside initPixel)
    initPixel();
  }, []);
  return <div className="min-h-screen bg-[#0f0f14] text-white font-sans selection:bg-[#d4a853] selection:text-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <BonusSection data-id="element-6" />
        <CheckoutSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
      </main>

      <footer className="py-12 bg-black text-center text-gray-600 text-sm border-t border-white/5" data-id="element-9">
        <div className="max-w-6xl mx-auto px-4" data-id="element-10">
          <p data-id="element-11">
            © 2026 Psicología del Apego Moderno. Todos los derechos reservados.
          </p>
          <p className="mt-2" data-id="element-12">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-13" />
    </div>;
}